import { useEffect } from "preact/hooks";

export function BannerAd() {
  useEffect(() => {
    try {
      // Ensure the global adsbygoogle array exists, then push an empty object
      // to signal AdSense to process any unfilled ad units on the page.
      ((window as any).adsbygoogle = (window as any).adsbygoogle || []).push({});
      console.log("AdSense push called."); // Add for debugging
    } catch (e) {
      console.error("AdSense push error:", e);
    }
  }, []);
  return (
    <div>
      <script
        async
        src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5273175411383448"
        crossorigin="anonymous"
      >
      </script>
      <ins
        class="adsbygoogle"
        style="display:inline-block;width:120px;height:700px"
        data-ad-client="ca-pub-5273175411383448"
        data-ad-slot="2094050956"
      >
      </ins>
      <script>
        (adsbygoogle = window.adsbygoogle || []).push({});
      </script>
    </div>
  );
}
